import React from "react";
import { Text, View, StyleSheet } from "react-native";

import t from "@constants/localization";
import NoOrders from "@assets/svg/RRD/NoOrders";
import colors from "@constants/color";

const EmptySearchList = () => {
  return (
    <View style={styles.loadingView}>
      <View style={styles.emptyView}>
        <NoOrders />
        <Text style={styles.emptyText1}>
          {t(`SearchOrder/noResultFoundText`)}
        </Text>
        <Text style={styles.emptyText2}>
          {t(`SearchOrder/noResultFoundSubText`)}
        </Text>
        <View style={{ height: 50 }} />
      </View>
    </View>
  );
};
const styles = StyleSheet.create({
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    backgroundColor: colors.white,
  },
  emptyView: {
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
  emptyText1: {
    fontSize: 18,
    lineHeight: 27,
    color: colors.mediumBlack,
    marginTop: 16,
    fontWeight: "600",
  },
  emptyText2: {
    fontSize: 14,
    lineHeight: 20,
    color: colors.lightBlack,
    marginTop: 8,
    fontWeight: "400",
  },
});

export default EmptySearchList;
